export default __webpack_public_path__ + "static/media/CH.bb13e8d7.svg";